module.exports = __webpack_public_path__ + "img/ic-ecommerce.d1fa3848.svg";